import Layout from "@/components/Layout";
import { AlertTriangle, Info as InfoIcon, Heart } from 'lucide-react';

const Info = () => {
  return (
    <Layout>
      <section className="py-24 bg-gradient-to-b from-white to-fembot-light-pink dark:from-gray-800 dark:to-gray-900 min-h-screen flex items-center">
        <div className="container-custom max-w-4xl mx-auto px-4">
          <div className="flex flex-col items-center">
            <div className="flex items-center gap-3 bg-red-100 border border-red-300 text-red-800 dark:bg-red-900/40 dark:text-red-200 rounded-xl px-8 py-5 mb-10 text-center font-semibold text-xl shadow-lg">
              <AlertTriangle className="w-8 h-8 text-red-500" />
              <span>
                <span className="font-bold">Important:</span> This service will be{' '}
                <span className="font-bold">discontinued on June 22, 2025</span> and will no longer be available after that date.
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl font-extrabold text-fembot-pink mb-8 text-center drop-shadow-lg flex flex-col items-center">
              <img
                src="/logoImage.png"
                alt="Fembot Logo"
                className="w-24 h-24 mb-4 rounded-full shadow-xl border-4 border-fembot-pink bg-white"
              />
              Fembot is shutting down
            </h1>
            <p className="text-2xl text-gray-700 dark:text-gray-200 mb-10 text-center max-w-2xl">
              After this amazing time, the Fembot service will be permanently discontinued on{' '}
              <span className="font-bold">June 22, 2025</span>. From this date, the bot will no longer be available and
              cannot be added to Discord servers.
            </p>
            <div className="w-full grid md:grid-cols-3 gap-8 mb-12">
              <div className="bg-white/80 dark:bg-gray-800/60 rounded-2xl p-6 shadow-md flex flex-col items-center">
                <InfoIcon className="w-10 h-10 text-fembot-pink mb-3" />
                <h2 className="text-xl font-bold text-fembot-pink mb-2">What does this mean?</h2>
                <ul className="list-disc pl-4 text-gray-800 dark:text-gray-100 text-base text-left">
                  <li>Fembot will go offline on June 22, 2025 and all features will be disabled.</li>
                  <li>It will no longer be possible to add the bot to new servers.</li>
                  <li>Existing integrations will stop working after the shutdown date.</li>
                </ul>
              </div>
              <div className="bg-white/80 dark:bg-gray-800/60 rounded-2xl p-6 shadow-md flex flex-col items-center text-center">
                <div className="flex flex-col items-center mb-2">
                  <AlertTriangle className="w-10 h-10 text-yellow-500 mb-3" />
                  <h2 className="text-xl font-bold text-fembot-pink mb-2">Why is Fembot shutting down?</h2>
                </div>
                <p className="text-gray-700 dark:text-gray-200 text-base">
                  The decision to discontinue was made after careful consideration.<br />
                  Reasons include changing requirements, technical and economic factors, and a focus on new projects.
                </p>
              </div>
              <div className="bg-white/80 dark:bg-gray-800/60 rounded-2xl p-6 shadow-md flex flex-col items-center">
                <Heart className="w-10 h-10 text-fembot-pink mb-3" />
                <h2 className="text-xl font-bold text-fembot-pink mb-2">What should you do?</h2>
                <ul className="list-disc pl-4 text-gray-800 dark:text-gray-100 text-base text-left">
                  <li>Please remove Fembot from your servers in time to avoid error messages.</li>
                  <li>Back up any important data or settings, as access will no longer be possible after shutdown.</li>
                  <li>If you have questions or need support, you can contact the support team until June 22, 2025.</li>
                </ul>
              </div>
            </div>
            <div className="mt-16 text-center text-2xl text-gray-600 dark:text-gray-400 font-semibold flex flex-col items-center">
              Thank you to all users for your trust and support over the time!<br />
              The Fembot team wishes you and your communities all the best {"<3"}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Info;
